import { render } from "./DownloadCV.vue?vue&type=template&id=63be35d8"
import script from "./DownloadCV.vue?vue&type=script&lang=js"
export * from "./DownloadCV.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__